import { EventEmitter, Injectable, Output } from '@angular/core';
import * as RecordRTC from 'recordrtc';
import html2canvas from 'html2canvas';
import { from, Observable, of, Subject, throwError, timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  catchError,
  delay,
  filter,
  map,
  mergeMap,
  take,
  takeUntil,
  timeout,
  finalize
} from 'rxjs/operators';
import {
  CipiaMultimediaParam,
  IntervalTime,
  IntervalType,
  MultimediaItem,
  SourceCipiaMultimedia,
  TypeCipiaMultimedia,
  VideoOnDemandTime,
} from '../models/interfaces';
import { ResponseInterface } from 'src/app/core/interfaces/response-interface';
import { WebSocketDataService } from 'src/app/vehicles/services/webSocketData.service';
import Swal from 'sweetalert2';
import moment, { duration } from 'moment';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { IndexedDbService } from 'src/app/shared/services/indexed-db.service';
import { CustomToastMessagessService } from 'src/app/map/services/custom-toast-messagess.service';
import { Evaluation, Alert } from 'src/app/alerts/models/alert.interface';
import { event } from 'jquery';
import { WaitTimeService } from 'src/app/events/services/wait-time.service';
import { EventService } from 'src/app/events/services/event.service';
import { HistorialService } from 'src/app/historial/services/historial.service';
import { MomentService } from 'src/app/vehicles/services/moment.service';
import { MultimediaStoreService } from './multimedia-store.service';
import { Subscription } from 'rxjs';

interface IMultimedias {
  [key: string]: MultimediaItem[];
}

@Injectable({
  providedIn: 'root',
})
export class MultimediaService {
  private mediaStream: any;
  private canvasStream: any;
  private audioStream: any;
  private recorder: any;
  private _mediaStream = new Subject<any>();
  private _blob = new Subject<any>();
  private _stateChange = new Subject<any>();
  //@Output() onStop: EventEmitter<boolean> = new EventEmitter<boolean>();

  public blob: any;
  private canvas: HTMLCanvasElement | null = null;
  private canvas2d: HTMLCanvasElement | null = null;
  private ctx: CanvasRenderingContext2D | null = null;

  private captureInterval: any;
  public isRecording = false;

  public multimediaCipiaItems: IMultimedias = {};
  public onDemandLoader = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private http: HttpClient,
    private webSocketDataService: WebSocketDataService,
    private sanitizer: DomSanitizer,
    private customToastMessagess: CustomToastMessagessService,
    private eventService: EventService,
    private momentService: MomentService,
    public store: MultimediaStoreService
  ) {}

  public async addMultimediaCipiaItem(
    eventId: string,
    item: MultimediaItem,
    uuid: string,
    event?: {
      event: Alert;
      element?: HTMLElement;
      multimediaParams: CipiaMultimediaParam;
    }
  ): Promise<void> {
    this.addMultimediaCipiaItemToUuid(uuid, item);
    const lastIndex = this.getLastMultimediaCipiaItemIndex(uuid);
    await this.loadMediaFromMultimediaItem(
      lastIndex,
      eventId,
      uuid,
      event
    );
  }
  public loadMediaFromMultimediaItem2(
    activeIndex: number,
    parentEventId: string,
    uuid: string,
    event?: {
      event: Alert;
      element?: HTMLElement;
      multimediaParams: CipiaMultimediaParam;
    },
    onFinish?: () => void
  ): Promise<void> {
    const media = this.store.getMultimediaByEventIdAndActiveIndex(uuid, activeIndex);

    return new Promise<void>(async (resolve, reject) => {
      try {
        if (media.url || media.loading || media.completed) {
          console.log("Media ya cargada o en proceso, se omite carga.");
          resolve();
        }

        media.loading = true;

        if (event) {
          this.showMultimediaToast(
            'init',
            `SOLICITUD EN PROCESO`,
            `Se le notificará cuando el video se encuentre disponible.`,
            event
          );
        }

        const { imei, eventId, type, source, seconds } = media.params!;
        const eventDetails = event ?? this.getEventDetails(uuid, media.params!);

        const blobItem = await this.getMediaFromEvent(
          imei,
          eventId!,
          type,
          source,
          undefined,
          seconds ?? undefined,
          10,
          7000,
          uuid,
          eventDetails
        ).toPromise();

        if (blobItem) {
          const { url, id } = blobItem;
          const safeUrl = this.sanitizer.bypassSecurityTrustUrl(url) as SafeUrl;
          this.store.updateUrlToMultimediaCipiaItem(uuid, safeUrl, url, id, activeIndex);
          media.completed = true;
        }

        media.loading = false;
        resolve();

      } catch (error) {
        media.loading = false;
        media.completed = false;
        console.error('mediaService: error load:', error);

        if (event) {
          this.showMultimediaToast(
            'error',
            'SOLICITUD EN PROCESO PARO',
            `Vuelve a intentarlo más tarde.`,
            event
          );
        }

        reject(error);
      } finally {
        if (onFinish) {
          console.log("Ejecutando función onFinish...");
          onFinish();
        }
      }
    });
  }

  public loadMediaFromMultimediaItem(
    activeIndex: number,
    parentEventId: string,
    uuid: string,
    event?: {
      event: Alert;
      element?: HTMLElement;
      multimediaParams: CipiaMultimediaParam;
    },
    onFinish?: () => void
  ): Promise<void> {
    console.log("onFinish value:", onFinish);
    //return new Promise(()=>{})
    let media = this.store.getMultimediaByEventIdAndActiveIndex(
      uuid,
      activeIndex
    );
    return new Promise<void>((resolve, reject) => {

      console.log("multimedia service: load media to uuid", media, `type: ${media.type}`);

      if (media.url) {
        console.log("multimedia service: load media to uuid - media url generated", `type: ${media.type}`);
        media.loading = false;
        media.completed = true;
        resolve();
        return;
      }

      if (media.completed) {
        console.log("multimedia service: load media to uuid - media completed", `type: ${media.type}`);
        media.loading = false;
        resolve();
        return;  
      }

      if (media.loading) {
        console.log("multimedia service: load media to uuid - media loading", `type: ${media.type}`);
        resolve();
        return;  
      }

      if (event) {
        this.showMultimediaToast(
          'init',
          `SOLICITUD EN PROCESO`,
          `Se le notificará cuando el video se encuentre disponible.`,
          event
        );
      }

      media.loading = true;
      console.log("multimedia service: load media to uuid process media", media); 

      const { imei, eventId, type, source, seconds } = media.params!;
      const eventDetails = event ?? this.getEventDetails(uuid, media.params!);

      this.getMediaFromEvent(
        imei,
        eventId!,
        type,
        source,
        undefined,
        seconds ?? undefined,
        10,
        7000,
        uuid,
        eventDetails
      )
        .toPromise()
        .then((blobItem) => {
          if (blobItem) {
            const { url, id } = blobItem;
            const safeUrl = this.sanitizer.bypassSecurityTrustUrl(
              url
            ) as SafeUrl;
            this.store.updateUrlToMultimediaCipiaItem(
              uuid,
              safeUrl,
              url,
              id,
              activeIndex
            );
            media.loading = false;
            media.completed = true;
          }
          console.log("onFinish value:", onFinish);
          console.log("multimedia service : to load media from event")
          if(onFinish){
            console.log("multimedia service : to load media from event on finish")
            onFinish()
          }
          resolve();
        })
        .catch((error) => {
          media.loading = false;
          media.completed = false;
          console.log('mediaSevice: error load:', error);
          if(event){
            this.showMultimediaToast(
              'error',
              'SOLICITUD EN PROCESO PARO',
              `Vuelve a intentarlo mas tarde.`,
              event
            );
          }
          reject();
        });
        
    });
  }

  private getEventDetails(uuid: string, mediaParams: CipiaMultimediaParam) {
    return {
      event:
        (this.eventService.events.find(
          (t) => t.uuid_event === uuid
        ) as Alert) ??
        (this.eventService.eventsHistorial.find(
          (t: Alert) => t.uuid_event === uuid
        ) as Alert),
      multimediaParams: mediaParams,
    };
  }
  private getMediaFromEvent(
    imei: string,
    eventId: string,
    type: string = 'video',
    source: string = 'CABIN',
    index: number = 0,
    time_before_call = 0,
    maxRetries = 2,
    retryInterval = 5000,
    uuid: string,
    event?: {
      event: Alert;
      element?: HTMLElement;
      multimediaParams: CipiaMultimediaParam;
    }
  ): Observable<any> {
    console.log("multimedia get medi from evetn", type, imei, eventId)
    return timer(time_before_call * 500).pipe(
      mergeMap(() => {
        return this.tryGetMedia(
          imei,
          eventId,
          type,
          source,
          index,
          maxRetries,
          retryInterval,
          uuid
        );
      }),
      catchError((e) => {
        return throwError(e);
      })
    );
  }
  private tryGetMedia(
    imei: string,
    eventId: string,
    type: string,
    source: string,
    index: number,
    maxRetries: number,
    retryInterval: number,
    uuid: string
  ): Observable<any> {
    const endpoint = `${
      environment.apiUrl
    }/api/media/${type}/${imei}/${eventId}/${source}/${parseInt(
      index.toString()
    )}`;
    return this.http.get(endpoint, { responseType: 'blob' }).pipe(
      map(async (blob) => {
        console.log(endpoint, "multimedia get")
        return await this.saveBlob(blob, {
          imei: imei,
          eventId: eventId,
          type: type as TypeCipiaMultimedia,
          from: uuid, // deberia ser date in UTC0 "2023-10-09 19:12:00" pero se esta usando para almacenar el uuid
          seconds: retryInterval,
          source: source as SourceCipiaMultimedia,
        });
      }),
      catchError((e) => {
        console.log(endpoint, "multimedia get error")
        if (e.status != 404) {
          return throwError(e);
        }
        if (maxRetries > 0) {
          maxRetries -= 1;
          // Reintentar después de un intervalo de tiempo
          return timer(retryInterval).pipe(
            mergeMap(() =>
              this.tryGetMedia(
                imei,
                eventId,
                type,
                source,
                index,
                maxRetries,
                retryInterval,
                uuid
              )
            )
          );
        } else {
          return throwError(e);
        }
      })
    );
  }

  // getters observables
  public getMediaStream() {
    return this._mediaStream.asObservable();
  }
  public getBlob() {
    return this._blob.asObservable();
  }
  public getStateChanges() {
    return this._stateChange.asObservable();
  }

  // function
  private videoRequestSubscriptions = new Subscription();

public getVideoOnDemand(
  option: VideoOnDemandTime = 'now',
  multimediaParams: CipiaMultimediaParam, 
  event: Alert | any,
  element: HTMLElement,
  saveToEventParam? : boolean
): Observable<void> {
  return new Observable((subscriber) => {
    this.onDemandLoader = true;
    const isNow = option === 'now';
    const typeInterval: IntervalType = isNow ? 'recording' : 'retrieve';

    // Mostrar notificación al usuario
    this.showMultimediaToast(
      'info',
      'SOLICITUD RECIBIDA',
      'Se le notificará cuando el video se encuentre disponible.',
      { event, element, multimediaParams },
      !isNow
    );

    // Seleccionar el observable adecuado
    const videoOnDemandRequest$ = isNow
      ? this.recordVideo(multimediaParams)
      : this.retrieveVideoFrom(multimediaParams);

    if(saveToEventParam){
      console.log("event to get video deman ", event)
    }

    videoOnDemandRequest$.pipe(
      finalize(() => {
        console.log("loader on demal loader end")
        this.onDemandLoader = false;
      })
    ).subscribe({
      next: (frame) => {
        console.log("frame complete get to event", frame)
        try {
          if(saveToEventParam && frame.Parametros?.eventId){
            this.saveVideoDemandToServer(
              event.fecha_tracker,
              event.uuid_event,
              frame.Parametros.eventId,
              event.parametrosString
            )
          }
          this.processFrameFromVideoOnDemand(
            typeInterval,
            multimediaParams,
            frame,
            event,
            element
          );
          subscriber.next();
          subscriber.complete();
        } catch (error) {
          subscriber.error(error);
        }
      },
      error: (error) => {
        console.error('Error en solicitud de video:', error);
        this.showMultimediaToast(
          'error',
          'SOLICITUD NO PROCESADA',
          this.getErrorMessage(error),
          { event, element, multimediaParams },
          false
        );
        subscriber.error(error);
      }
    });
  });
}

private getErrorMessage(error: any): string {
  return error.message || 
         error.toString() || 
         'Ocurrió un error al procesar la solicitud';
}

public cleanupVideoRequests(): void {
  this.videoRequestSubscriptions.unsubscribe();
  this.videoRequestSubscriptions = new Subscription();
}
  public async screenShot(element: HTMLElement): Promise<void> {
    try {
      this.canvas2d = this.createCanvas(element, 'd-none');
      this.ctx = this.canvas2d.getContext('2d');
      await this.drawCanvasWithTimestamp(this.canvas2d, element, this.ctx!);
      // Crea un elemento de enlace
      const dataURL = this.canvas2d.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = dataURL;
      a.download = `${Date.now()}.png`;
      a.click();
      this.canvas2d!.remove();
    } catch (error) {
      console.error('Error capturing screenshot:', error);
    }
  }
  public async startRecording(element: HTMLElement) {
    try {
      this.canvas2d = this.createCanvas(element);
      this.ctx = this.canvas2d.getContext('2d');

      this.captureInterval = setInterval(async () => {
        if (
          this.recorder &&
          this.recorder.getBlob() &&
          this.recorder.getBlob().size
        ) {
          // this line checks whether recorder is stopped
          return;
        }
        this.captureCanvasFrame(this.canvas2d!, element, this.ctx!);
        // Dibuja la marca de tiempo en el canvas
        this.drawTimestamp(this.canvas2d!, this.ctx!);
      }, 1000);
      //requestAnimationFrame(() => {});

      // Obtener el audioStream
      this.audioStream = await this.getAudioStream();
      console.log('Obtener el audioStream', element);
      //const canvas = await html2canvas(element)
      console.log('html2canvas.default(element);');

      // Capturar el stream del canvas
      // @ts-ignore
      this.canvasStream = this.canvas2d.captureStream();
      console.log('Capturar el stream del canvas');

      // Crear una nueva MediaStream para combinar las pistas de audio y video
      this.mediaStream = new MediaStream();
      console.log(
        'Crear una nueva MediaStream para combinar las pistas de audio y video'
      );

      // Obtener y agregar las pistas de audio a finalStream
      const audioTracks = this.audioStream.getAudioTracks();
      audioTracks.forEach((track: any) => {
        this.mediaStream.addTrack(track);
        console.log('add audiotrack en el stream del canvas');
      });

      // Obtener y agregar las pistas de video a finalStream
      const videoTracks = this.canvasStream.getVideoTracks();
      videoTracks.forEach((track: any) => {
        this.mediaStream.addTrack(track);
        console.log('add videorack en el stream del canvas');
      });

      // Iniciar la grabación con RecordRTC
      this._mediaStream.next(this.mediaStream);
      console.log('enviar por observable');

      this.recorder = this.initializeVideoRecorder(this.mediaStream);
      console.log('instanciar recorder');

      await this.recorder.startRecording();
      this.isRecording = true;
      console.log('iniciar grabacion recorder');
    } catch (error) {
      this.isRecording = false;
      console.error('Error al iniciar la grabación:', error);
    }
  }
  public async startRecordingWindow() {
    await this.handleRecording();
  }
  public async handleRecording() {
    try {
      this.audioStream = await this.getAudioStream();
      this.mediaStream = await this.getAudioAndVideoStream();

      this.mediaStream = new MediaStream([
        ...this.mediaStream.getTracks(),
        ...this.audioStream.getTracks(),
      ]);
      this._mediaStream.next(this.mediaStream);
      this.recorder = new RecordRTC(this.mediaStream, { type: 'video' });
      this.recorder.onStateChanged = function (state: any) {
        console.log('STATEEE: ', state);
        this._stateChange.next(state);
      };
      await this.recorder.startRecording();
      this.isRecording = true;
    } catch (error) {
      this.isRecording = false;
    }
  }
  public async stopRecording() {
    if (this.captureInterval) {
      clearInterval(this.captureInterval);
    }
    console.log('STARTING STOP RECORDING-------1');
    console.log(this.recorder);

    if (!this.recorder) {
      console.log('STARTING STOP RECORDING-------2');
      return;
    }
    console.log('STARTING STOP RECORDING-------3');

    await this.stopRecorder();
  }
  public retrieveVideoFrom(
    mediaRequest: CipiaMultimediaParam
  ): Observable<any> {
    mediaRequest.from = this.momentService.toUTC(
      mediaRequest.from!,
      true
    ) as string;
    return this.processMediaRequest(
      mediaRequest,
      '/api/media/retrieve',
      'retrieve'
    );
  }
  public recordVideo(mediaRequest: CipiaMultimediaParam): Observable<any> {
    return this.processMediaRequest(
      mediaRequest,
      '/api/media/record',
      'record'
    );
  }

  private processMediaRequest(
    mediaRequest: CipiaMultimediaParam,
    endpoint: string,
    action: 'retrieve' | 'record'
  ): Observable<any> {
    return new Observable((observer) => {
      if (this.isValidMediaRequestDuration(mediaRequest)) {
        observer.error(
          'La duración del video no está dentro del rango requerido (10-60 segundos). Por favor, vuelve a intentarlo.'
        );
        observer.complete();
      }

      const frameSubscriptionSocket = this.configureFrameSocket(mediaRequest);

      const frameSubscription = frameSubscriptionSocket.subscribe(
        (frame) => {
          console.log("MULTIMEDIA PROCESADA")
          observer.next(frame);
          observer.complete();
        },
        (error) => {
          console.log("MULTIMEDIA PROCESADA ERROR", error)
          if (error.name === 'TimeoutError') {
            observer.error(
              `Se superó el tiempo de espera para ${action} del video, verifique que la unidad se encuentra encendida e inténtelo de nuevo.`
            );
          } else {
            observer.error(
              `Ocurrió un error inesperado al solicitar el video. Por favor, vuelva a intentarlo más tarde.`
            );
          }
          if (action == 'record') {
            observer.complete();
          }
        }
      );

      // Realizar la llamada HTTP al endpoint
      console.log('multimediaService : send ', mediaRequest);
      this.http
        .post<ResponseInterface>(environment.apiUrl + endpoint, mediaRequest)
        .subscribe(
          (resp) => {
            if (!resp.success) {
              if (action == 'record') {
                this.onDemandLoader = false;
                observer.error(resp.message);
              } else {
                observer.error(resp);
              }
              observer.complete();
              frameSubscription.unsubscribe();
            } else {
              // observer.next(
              //   {
              //     Parametros : {
              //       eventId : resp.data.code
              //     }
              //   }
              // )
              // observer.complete()
            }
          },
          (error) => {
            if (action == 'retrieve') {
              this.handleProcessMediaRequestRetriveApiError(
                error,
                observer,
                frameSubscription
              );
            } else {
              this.handleProcessMediaRequestRecordApiError(
                error,
                observer,
                frameSubscription
              );
            }
          }
        );

      if (action == 'retrieve') {
        mediaRequest.from = this.momentService.toLocal(
          mediaRequest.from!,
          true
        ) as string;
      }
    });
  }

  public hasItemsForUuid(uuid : string) {
    return this.store.hasItemsForUuid(uuid)
  }
  
  private peticionesVideoDemand: any[] = [];

  public addNewVideoDemand(demandParams: any): void {
    this.peticionesVideoDemand.push(demandParams);
  }

  public includeDemandInPeticionesDemand(params: any): boolean {
    return this.peticionesVideoDemand.some((paramDemand) => {
      return paramDemand.eventId === params.eventId &&
        paramDemand.from === params.from &&
        paramDemand.imei === params.imei &&
        paramDemand.seconds === params.seconds &&
        paramDemand.source === params.source &&
        paramDemand.type === params.type;
    });
  }

  public removeVideoDemand(params: any): void {
  this.peticionesVideoDemand = this.peticionesVideoDemand.filter((paramDemand) => {
    return !(
      paramDemand.eventId === params.eventId &&
      paramDemand.from === params.from &&
      paramDemand.imei === params.imei &&
      paramDemand.seconds === params.seconds &&
      paramDemand.source === params.source &&
      paramDemand.type === params.type
    );
  });
}

  public saveVideoDemandToServer(
    fechaTracker: string,
    uuid: string,
    videoEventId: string,
    parametros: string,
  ) {
    const formated = this.momentService.toUTC(fechaTracker, true) as string
    const fechaFormateada = formated.replace(/\//g, '-');
    
    console.log("saved multimide to server media",  {
      fecha_tracker: fechaFormateada,
      uuid_event: uuid,
      new_event_id: videoEventId,
      parametros: parametros
    })

    this.http.post(environment.apiUrl + "/api/events/changeParameters", {
      fecha_tracker: fechaFormateada,
      uuid_event: uuid,
      new_event_id: videoEventId,
      parametros: parametros
    }).subscribe({
      next: (response) => {
        // ✅ Éxito - respuesta del servidor
        console.log('Respuesta del servidor:', response);
        // aquí puedes mostrar un mensaje o hacer otras acciones
      },
      error: (error) => {
        // ❌ Error al enviar
        console.error('Error al enviar datos al servidor:', error);
        // aquí puedes mostrar un mensaje de error al usuario
      }
    });

  }


  private async processFrameFromVideoOnDemand(
    intervalType: IntervalType,
    multimediaParams: CipiaMultimediaParam,
    frame: any,
    event: Alert,
    element: HTMLElement
  ) {
    const { eventId, type, from, seconds } = multimediaParams;
    const auxMultimediaParams = {
      ...multimediaParams,
      eventId: frame.Parametros.eventId,
    };

    const startTime = this.momentService.toMoment(from!, true);
    const endTime = this.momentService.setWithOptions(
      from!,
      seconds,
      'seconds',
      true
    );
    const description = `Desde: ${startTime} hasta: ${endTime}`;
    const interval = this.getInterval(from!, 0, seconds!, intervalType);

    const multimediaItem = {
      type,
      params: auxMultimediaParams,
      description,
      url: '',
      objectUrl : "",
      blobId: '',
      interval,
    };

    await this.addMultimediaCipiaItem(
      eventId!,
      multimediaItem,
      event.uuid_event,
      { event, element, multimediaParams }
    );
    this.onDemandLoader = false;
    const messageToast =
      intervalType == 'recording'
        ? 'La grabación está disponible. Por favor, diríjase al evento para verlo.'
        : 'El video está disponible. Por favor, diríjase al evento para verlo';

    this.showMultimediaToast(
      'success',
      `SOLICITUD COMPLETADA`,
      messageToast,
      {
        event,
        element,
        multimediaParams,
      },
      false
    );
  }
  private configureFrameSocket(
    mediaRequest: CipiaMultimediaParam
  ): Observable<any> {
    const seconds = mediaRequest.seconds ?? 5;
    const adjustedSeconds = seconds < 14 ? seconds + seconds : seconds;
    const timeoutMs = adjustedSeconds * 2000;
    return this.webSocketDataService.callback.pipe(
      filter((frame) => {
        console.log('frame', frame);

        if(mediaRequest.imei === frame.IMEI.toString() && frame.Parametros.includes('ExternalEvent')){
          console.log("frame : se encotro evento de video")
        }
        return (
          mediaRequest.imei === frame.IMEI.toString() &&
          frame.Parametros.includes('ExternalEvent')
        );
      }),
      mergeMap((frame) => this.processFrameParams(frame)),
      take(1),
      timeout(timeoutMs)
    );
  }
  private processFrameParams(frame: any): Observable<any> {
    console.log('frame', frame);
    const objParams: any = {};
    frame.Parametros.split('|').forEach((item: string) => {
      const [key, value] = item.split('=');
      objParams[key] = value;
    });
    frame.Parametros = objParams;
    return from([frame]);
  }
  private handleProcessMediaRequestRetriveApiError(
    error: any,
    observer: any,
    frameSubscription: any
  ) {
    const errorCod: Record<number, string> = {
      401: 'Tu sesión no tiene los permisos necesarios. Verifica tus credenciales e inténtalo nuevamente.',
      403: 'El dispositivo no se encuentra registrado en el servidor.',
      404: 'No se ha encontrado información disponible para la fecha solicitada en el equipo CIPIA.',
      408: 'El dispositivo CIPIA de la unidad aún no se encuentra disponible. Por favor, inténtelo de nuevo más tarde.',
      422: 'No se ha encontrado información disponible para la fecha solicitada en el equipo CIPIA.',
      500: 'No se pudo conectar al servidor del dispositivo CIPIA.',
    };

    observer.error(
      errorCod[error.status] ??
        'Ha ocurrido un error inesperado. Por favor, inténtelo de nuevo más tarde.'
    );
    observer.complete();
    frameSubscription.unsubscribe();
  }
  private handleProcessMediaRequestRecordApiError(
    error: any,
    observer: any,
    frameSubscription: any
  ) {
    console.log("error al obtener video lol")
    this.onDemandLoader = false;
    frameSubscription.unsubscribe();
    observer.error(error.error.messages);
    observer.complete();
  }

  private async stopRecorder(): Promise<void> {
    console.log('Deteniendo grabadora');
    await new Promise<void>((resolve) => {
      this.isRecording = false;
      this.blob = this.recorder.getBlob();
      this._blob.next(URL.createObjectURL(this.blob));
      if (this.canvas2d) {
        this.canvas2d!.remove();
      }
      this.mediaStream.getTracks().forEach((track: any) => track.stop());
      console.log('mediastream.stop');
      this.audioStream.getTracks().forEach((track: any) => track.stop());
      console.log('audiotream.stop');
      if (this.canvasStream) {
        this.canvasStream.getTracks().forEach((track: any) => track.stop());
        console.log('canvasstream.stop');
      }
      this.recorder.destroy();
      resolve();
    });
    console.log('Grabación detenida');
  }
  public downloadRecording() {
    RecordRTC.invokeSaveAsDialog(this.blob, `${Date.now()}.webm`);
  }
  public clearRecording() {
    this.blob = null;
    this.canvas!.remove();
    this.recorder = null;
    this.mediaStream = null;
    this.audioStream = null;
    this.canvasStream = null;
    this.isRecording = false;
  }

  // util media stream
  private createCanvas(
    element: HTMLElement,
    className = ''
  ): HTMLCanvasElement {
    const canvas2d = document.createElement('canvas')!; // OUR OWN invisible CANVAS
    canvas2d.width = element.clientWidth;
    canvas2d.height = element.clientHeight;
    canvas2d.className = className;
    (document.body || document.documentElement).appendChild(canvas2d);
    return canvas2d;
  }
  private initializeVideoRecorder(mediaStream: MediaStream): RecordRTC {
    return new RecordRTC(mediaStream, {
      type: 'video',
    });
  }
  private drawCanvasWithTimestamp(
    canvas: HTMLCanvasElement,
    element: HTMLElement,
    ctx: CanvasRenderingContext2D
  ): Promise<void> {
    return new Promise(async (resolve) => {
      const img = await html2canvas(element, {
        removeContainer: false,
        useCORS: true,
        allowTaint: true,
      });
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      this.drawTimestamp(canvas, ctx);
      resolve();
    });
  }
  private drawTimestamp(
    canvas: HTMLCanvasElement,
    ctx: CanvasRenderingContext2D
  ): void {
    const currentTime = new Date().toLocaleString();
    ctx.fillStyle = 'black';
    ctx.shadowColor = 'white';
    ctx.shadowBlur = 10;
    ctx.font = '24px Arial';
    const x = 20;
    const y = canvas.height - 20;
    ctx.fillText(currentTime, x, y);
  }
  private getAudioStream(): Promise<MediaStream> {
    return navigator.mediaDevices.getUserMedia({
      audio: true,
    });
  }
  private getAudioAndVideoStream(): Promise<MediaStream> {
    // @ts-ignore
    return navigator.mediaDevices.getDisplayMedia({
      audio: true,
      video: true,
    });
  }
  private async captureCanvasFrame(
    canvas2d: HTMLCanvasElement,
    element: HTMLElement,
    ctx: CanvasRenderingContext2D
  ) {
    // looper keeps calling this method until recording stops
    const canvasresult = await this.getCanvaResult(element);
    ctx.clearRect(0, 0, canvas2d.width, canvas2d.height);

    // draw html2canvas resulting canvas on our own canvas
    ctx.drawImage(canvasresult, 0, 0, canvas2d.width, canvas2d.height);
  }
  private getCanvaResult(element: HTMLElement) {
    return html2canvas(element, {
      useCORS: true,
      allowTaint: true,
    });
  }

  // storage
  private async saveBlob(
    blob: Blob,
    multimediaItemWaitTime: CipiaMultimediaParam
  ) {
    return await this.store.saveBlob(blob, blob.type, multimediaItemWaitTime);
  }
  private getLastMultimediaCipiaItemIndex(uuid: string): number {
    return this.store.getLastMultimediaCipiaItemIndex(uuid);
  }
  private addMultimediaCipiaItemToUuid(uuid: string, item: MultimediaItem) {
    this.store.addMultimediaCipiaItem(uuid, item);
  }
  public initializeNewMultimediaCipiaItem(uuid: string): void {
    this.store.initializeNewMultimediaCipiaItem(uuid);
  }
  public hasUuid_eventInMultimediaItems(eventId: string): boolean {
    return this.store.multimediaCipiaItems.hasOwnProperty(eventId);
  }
  public getMultimediaListByUuid(uuid: string): MultimediaItem[] {
    return this.store.getMultimediasByUuid(uuid);
  }
  public async clearMultimediaStorage() {
    await this.store.clearMultimediaStorage();
  }
  public async clearAllMultimediaStorage() {
    await this.store.clearAllMultimediaBlobFromIndexedDB();
  }
  public isEventMultimediaLoaded(uuid : string) : boolean{
    return this.store.hasUuid_eventInMultimediaItems(uuid)
  }
  public deleteMultimediaFromEvent(uuid : string) : Promise<void>{
    return this.store.deleteMultimediaByEventId(uuid);
  }

  // util
  private showMultimediaToast(
    severity: string,
    summary: string,
    detail: string,
    event: {
      event: Alert;
      element?: HTMLElement;
      multimediaParams: CipiaMultimediaParam;
    },
    sticky: boolean = true,
    error?: string
  ) {
    const { event: alertEvent, multimediaParams, element } = event;

    const formattedMoment = this.momentService.toMoment(
      multimediaParams.from!,
      true
    );
    const periodStart = formattedMoment;
    const periodEnd = this.momentService.setWithOptions(
      multimediaParams.from!,
      multimediaParams.seconds,
      'seconds',
      true
    );

    const toastData = {
      unit: `Unidad: ${alertEvent.nombre_objeto}`,
      datetime: `Fecha: ${alertEvent.fecha_tracker}`,
      moment: {
        periodo: `Periodo: ${formattedMoment} (${periodStart} - ${periodEnd})`,
        error,
      },
      dataEvent: alertEvent,
      dataHTML: element!,
    };

    this.customToastMessagess.addCustomToast({
      id: `${alertEvent.uuid_event}_${multimediaParams.timestamp}`,
      severity,
      summary,
      detail,
      data: toastData,
      sticky,
      closable: false,
    });
  }
  public getInterval(
    event_date_time: string,
    add_start_number: number,
    add_end_numbrer: number,
    type?: IntervalType
  ): IntervalTime {
    const end =
      this.getMomentLocalWithOptions(event_date_time, add_end_numbrer) +
      'time format';
    const start =
      this.getMomentLocalWithOptions(event_date_time, add_start_number) +
      'time format';
    return {
      start,
      end,
      type: type ?? 'event',
    };
  }
  private getMomentLocalWithOptions(
    eventDate: string,
    addNumber: number
  ): string {
    return this.momentService.toLocalWithOptions(
      eventDate,
      addNumber,
      'seconds',
      true
    ) as string;
  }
  private isValidMediaRequestDuration(
    mediaRequest: CipiaMultimediaParam
  ): boolean {
    return mediaRequest.seconds! > 60 || mediaRequest.seconds! < 10;
  }

  // reject Functions
  /*
  private initializeMultimediaStorage() {
    if (this.indexedDBService.isReady) {
      this.loadMultimediaCipiaItemsFromLocalStorage();
    } else {
      this.indexedDBService.completed.subscribe(() => {
        this.loadMultimediaCipiaItemsFromLocalStorage();
      });
    }
  }
  private async loadMultimediaCipiaItemsFromLocalStorage() {
    let events = this.localStorageService.getItem(
      EVENTS_MULTIMEDIA_KEY
    ) as string[];
    if (events) {
      events.map(async (event) => {
        //console.log("retrieving MultimediaCipiaItems from: ", event);

        let auxMultimediaCipiaItems: MultimediaItem[] =
          this.localStorageService.getItem(event) as MultimediaItem[];
        console.log('MultimediaCipiaItems data: ', auxMultimediaCipiaItems);
        if (auxMultimediaCipiaItems) {
          const promises: Promise<MultimediaItem>[] =
            auxMultimediaCipiaItems.map(async (item: MultimediaItem) => {
              const blobItem = await this.indexedDBService
                .getBlob(item.blobId!)
                .toPromise();
              //console.log("blobItem getBlob", blobItem);
              item.url = this.sanitizer.bypassSecurityTrustUrl(
                URL.createObjectURL(blobItem)
              ) as SafeUrl;
              return item;
            });

          // Esperar a que todas las promesas se resuelvan
          const resolvedItems = await Promise.all(promises);
          this.multimediaCipiaItems[event] = resolvedItems;
        }
      });
    }
    this.isLoadedMultimediaCipia = true;
    this.completedMultimediaCipia.emit();
    //console.log(" MultimediaCipiaItems loaded: ", this.multimediaCipiaItems);
  }
  private updateUrlToMultimediaCipiaItem(
    uuid: string,
    url: SafeUrl,
    blobId: string,
    index: number
  ) {
    this.multimediaCipiaItems[uuid][index].url = url;
    this.multimediaCipiaItems[uuid][index].blobId = blobId;
    this.localStorageService.updateItem(
      uuid,
      this.multimediaCipiaItems[uuid]
    );
    //console.log("update LocalStorage: ", this.localStorageService.getItem(eventId));
  }
  private initializeNewMultimediaCipiaItem2(uuid: string) {
    this.multimediaCipiaItems[uuid] = [];
    this.localStorageService.setItem(uuid, []);
    this.addEventToListInLocalStorage(uuid);
  }

  private addEventToListInLocalStorage(uuid: string) {
    let events = this.localStorageService.getItem(
      EVENTS_MULTIMEDIA_KEY
    ) as string[];
    console.log('eventsInLocalStorage: ', events);
    if (events) {
      events.push(uuid);
      this.localStorageService.updateItem(EVENTS_MULTIMEDIA_KEY, [...events]);
      //console.log("eventsInLocalStorageAfter: ", this.localStorageService.getItem(EVENTS_MULTIMEDIA_KEY) as string[]);
    } else {
      this.localStorageService.setItem(EVENTS_MULTIMEDIA_KEY, [uuid]);
      //console.log("eventsInLocalStorage append: ", this.localStorageService.getItem(EVENTS_MULTIMEDIA_KEY) as string[]);
    }
  }

  private async clearMultimediaStorage2() {
    let events = this.localStorageService.getItem(
      EVENTS_MULTIMEDIA_KEY
    ) as string[];

    if (events) {
      for (const event of events) {
        //console.log("deleting MultimediaCipiaItems from: ", event);

        let auxMultimediaCipiaItems: MultimediaItem[] =
          this.localStorageService.getItem(event) as MultimediaItem[];
        if (auxMultimediaCipiaItems) {
          for (const item of auxMultimediaCipiaItems) {
            await this.indexedDBService.deleteBlob(item.blobId!).toPromise();
            console.log('deleted: ', item.blobId!);
          }
        }
      }
    }
  }
  private async clearAllMultimediaStorage2() {
    await this.indexedDBService.deleteAllBlob().toPromise();
  }
  */
}
